import './App.css';
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home.tsx";
import Consortium from "./pages/Consortium.tsx";
import Microcredit from "./pages/Microcredit.tsx";
import Authors from "./pages/Authors.tsx";
import Coordinator from "./pages/Coordinator.tsx";
import ShortDescription from "./pages/ShortDescription.tsx";
import OnlineMeeting from "./pages/OnlineMeeting.tsx";
import OnlineNextMeeting from "./pages/OnlineNextMeeting.tsx";
import Survey from "./pages/Survey.tsx";
import WorkingMeeting from "./pages/WorkingMeeting.tsx"
import OnlineTraining from "./pages/OnlineTraining.tsx";
import PodilskieReadings from "./pages/PodilskieReadings.tsx";
import OnlineTraining2026 from "./pages/OnlineTraining2026.tsx";
import HackathonTraining from "./pages/HackathonTraining.tsx";
import HackathonInOdesa from "./pages/HackathonInOdesa.tsx";
import ErasmusDays from "./pages/ErasmusDays.tsx";
import OnlineWorkshop from './pages/OnlineWorkshop.tsx';

function App() {

  return (
    <div className="App">
        <Routes>
            <Route path="/" element={ <Home/> } />
            <Route path="consortium" element={ <Consortium/> } />
            <Route path="microcredit" element={ <Microcredit /> } />
            <Route path="authors" element={ <Authors /> } />
            <Route path="coordinator" element={ <Coordinator /> } />
            <Route path="shortDescription" element={ <ShortDescription /> } />
            <Route path="onlineMeeting" element={ <OnlineMeeting /> } />
            <Route path="onlineNextMeeting" element={ <OnlineNextMeeting /> } />
            <Route path="survey" element={ <Survey /> } />
            <Route path="workingMeeting" element={ <WorkingMeeting /> } />
            <Route path="onlineTraining" element={<OnlineTraining />} />
            <Route path="podilskieReadings" element={<PodilskieReadings />}  />
            <Route path="onlineTraining2026" element={<OnlineTraining2026 />} />
            <Route path="hackathonTraining" element={<HackathonTraining />} />
            <Route path="hackathonInOdesa" element={<HackathonInOdesa />} />
            <Route path="erasmusDays" element={<ErasmusDays />} />  
            <Route path="onlineWorkshop" element={<OnlineWorkshop />} />
        </Routes>
    </div>
  );
}
export default App;